module.exports = __webpack_public_path__ + "img/asset.6fb38f76.svg";